import { AsyncActionOptions } from '../Store';
import { login, register } from '../../api/Rest/users';
import { UserId } from '../Base';
import { FirstParameter } from '../Utils';
import { ProfileJson } from '../UserStore';
import { UserJson } from '../UserStore';
import { RegionsCode } from '../../constants/region';

export enum LoginResult {
  Success = 'success',
  PreRegistered = 'preRegistered',
  Error = 'error',
  InvalidCredentials = 'invalidCredentials',
  Cancel = 'cancel',
  AvailableOauth2Id = 'available oauth2 id',
  SuccessReactivated = 'successReactivated',
  HaveSubAccounts = 'haveSubAccounts',
}

// export enum SwitchAccountResult {
//   Success = 'success',
//   SuccessReactivated = 'successReactivated',
//   Error = 'error',
//   IncorrectPassword = 'incorrect password',
//   AccountNotFound = 'account not found',
// }

export enum RegisterResult {
  Success = 'success',
  Error = 'error',
  EmailRegistered = 'emailAlreadyRegistered',
  UsernameRegistered = 'usernameAlreadyRegistered',
  ValidationError = 'validationError',
  PreRegistered = 'preRegistered',
}

export interface SessionTokens {
  exp: number;
  accessToken: string;
  refreshToken: string;
}

export interface RegisterRespond {
  result: RegisterResult;
  user?: UserJson;
  profile?: ProfileJson;
  tokens?: SessionTokens;
  password?: string;
}

export enum LogoutResult {
  Success = 'success',
  Error = 'error',
  HasUndoneTasks = 'hasUndoneTasks',
}

export interface SessionTokens {
  exp: number;
  accessToken: string;
  refreshToken: string;
}

export interface SessionStoreStateJson {
  activeUserId: UserId | null;
  tokenExpiredAt: Date | null;
  activeRegion: RegionsCode;
}

export interface SessionStoreState {
  activeUserId: UserId | null;
  tokenExpiredAt: Date | null;
  activeRegion: RegionsCode;
  scrolledPos: number | null;
}

export interface SessionStoreAction {
  register: (
    params: FirstParameter<typeof register>,
    options?: AsyncActionOptions,
  ) => Promise<RegisterRespond>;
  login: (
    params: FirstParameter<typeof login>,
    options?: AsyncActionOptions,
  ) => Promise<LoginResult>;
  logout: (
    forceLogout?: boolean,
    options?: AsyncActionOptions,
  ) => Promise<LogoutResult>;
  // refreshTokens: () => Promise<void>;
  setActiveRegion: (region: RegionsCode) => void;
  isLoggedIn: () => boolean;
  setScrollPos: (pos: number | null) => void;
}
